import { DebugTimerStartNode, DebugTimerEndNode } from './nodes/DebugTimerNode';
import { LogicNodeDefinition } from './LogicNodeDefinition';
import {
  TrueNode,
  FalseNode,
  ConsoleNode,
  NotNode,
  DiodeNode,
  DelayNode,
  ClockNode,
  WireNode,
  LeverNode,
  RandomNode,
} from './nodes';
import { ButtonNode } from './nodes/ButtonNode';

export class LogicNodeRegistry {
  private registry = new Map<string, LogicNodeDefinition<unknown>>();

  constructor() {
    this.register(TrueNode);
    this.register(FalseNode);
    this.register(ConsoleNode);
    this.register(DebugTimerStartNode);
    this.register(DebugTimerEndNode);
    this.register(NotNode);
    this.register(DiodeNode);
    this.register(DelayNode);
    this.register(ClockNode);
    this.register(WireNode);
    this.register(LeverNode);
    this.register(RandomNode);
    this.register(ButtonNode);
  }

  register<TState>(definition: LogicNodeDefinition<TState>) {
    this.registry.set(definition.type, definition as LogicNodeDefinition<unknown>);
  }

  has(type: string) {
    return this.registry.has(type);
  }

  get(type: string): LogicNodeDefinition<unknown> {
    const definition = this.registry.get(type);
    if (!definition) {
      throw new Error(`Logic node definition not found: ${type}`);
    }
    return definition;
  }
}

export const logicNodeRegistry = new LogicNodeRegistry();
